'use strict';

import axios from 'axios';
import mybase from './base64.js';
// axios 配置
axios.defaults.timeout = 12000; //设置超时时间



// 添加请求拦截器
axios.interceptors.request.use(
	(config) => {
		// loading
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
// 添加响应拦截器
axios.interceptors.response.use(function(response) {
	return response;
}, function(error) {
	// Do something with response error
	return Promise.reject(error);
});

function checkStatus(response) {
	// loading
	// 如果http状态码正常，则直接返回数据
	if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
		return response.data;
		// 如果不需要除了data之外的数据，可以直接 return response.data
	}
	// 异常状态下，把错误信息返回去

	return {
		status: -404,
		msg: '网络异常'
	};
}

function checkCode(res) {
	// 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
	if (res.status === -404) {
		alert(res.msg);
	}
	if (res.data && !res.data.success) {
		alert(res.data.error_msg);
	}
	return res;
}

function post(api, token, d) {
	// let temp_url = 'https://192.168.1.19:8686/api/Data' + api; //这是调用数据接口 测试 热点
	let temp_url = 'https://api.haojun.work/api/Data'+api; //这是调用数据接口 测试 热点
	// console.log('api=' + api);

	const requestData = {
		token: token,
		data: mybase.base_encode(d)
	};

	return axios({
			method: 'post',
			url: temp_url,
			data: requestData,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
		.then((response) => {
			var res = checkStatus(response);
			// console.log('处理后结果:', res);

			var backdata;

			if (res && res.statue === "1") {
				// 如果result存在，进行解码
				// console.log('接收数据库返回:', res.result);
				var js = JSON.parse(res.result)
				// console.log('JSON转换:', js);
				if (js.status === "1" && js.result) {
					try {
						backdata = mybase.decode(mybase.decode(js.result));
						backdata = backdata.replace(/[\r\n]/g, "");
						// console.log("解码成功:", backdata);
					} catch (error) {
						console.error("解码失败:", error);
						backdata = {
							data: {
								statue: "0",
								msg: "解码失败: " + error.message
							}
						};
					}
				} else {
					backdata = {
						data: {
							statue: "0",
							msg: "响应中没有result字段"
						}
					};
				}
			} else {
				// 错误处理
				// console.log("请求失败:", res);
				if (res && res.result) {
					try {
						backdata = mybase.decode(mybase.decode(res.result));
						backdata = backdata.replace(/[\r\n]/g, "");
					} catch (e) {
						backdata = JSON.stringify(res);
					}
				} else {
					backdata = {
						data: {
							statue: "0",
							msg: res.message || "请求失败"
						}
					};
				}
			}

			return backdata;
		})
		.catch((error) => {
			console.error('请求异常:', error);

			return {
				data: {
					statue: "0",
					msg: error.message || "网络错误"
				}
			};
		});
}

export function api_get(api, token, d) {
	return new Promise((resolve, reject) => {
		// console.log(menuvalue);
		post(api, token, d).then(res => {
			// console.log(res);

			resolve(res)
		});
	})
}